var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comments-widget"},[_c('CommentsList',{on:{"get-comments":_vm.getCommentsByPage}}),_c('AddCommentBox',{attrs:{"add-comment":_vm.addComment}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }